import { Button, Grid, List, ListItem, ListItemText, makeStyles, Paper } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeActionStatus, configActionRoes, getActionRoles, getConfigActionList, getRoleList, setActiveAction } from "redux/modules/configActionSlice";
import store from "redux/store";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(4),
        borderRadius: 16,
    },
    warpButton: {
        marginTop: 30,
        textAlign: 'right'
    },
    buttonSave: {
        marginLeft: 5,
        width: 120
    },
    menuRow: {
        fontWeight: "500", padding: "10px 15px", borderBottom: "1px solid lightgray", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer"
    },
    subMenu: {
        marginLeft: "15px", cursor: "pointer", backgroundColor: "whitesmoke", display: "flex", justifyContent: "space-between", alignItems: "center"
    },
    listItem: {
        border: '1px solid lightgray',
        cursor: 'pointer',
        '& span': {
            fontWeight: 500,
            fontSize: 13,
        }
    },
    actionSelected: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff'
    },
    roleCheckbox: {
        height: 20
    }
}));




function ConfigActionPage() {

    const classes = useStyles();
    const dispatch = useDispatch();



    const [state, setAction] = useState({
        actions: [],
        actionSelected: ''
    });



    const { list, roleSelected } = useSelector((state) => state.configAction);

    useEffect(() => {
        async function fetchData() {
            await dispatch(getConfigActionList());
            await dispatch(getRoleList());
            await dispatch(getActionRoles());

        }
        fetchData();


    }, [dispatch]);



    const handleOnSelectSubMenu = (actionMenu) => {
        const actionNo = (actionMenu.length > 0) ? actionMenu[0].actionNo : null;
        setAction({ actions: actionMenu, actionSelected: actionNo })
        dispatch(setActiveAction(actionNo));
    }

    const handleOnSelectAction = (actionNo) => {
        setAction({ ...state, actionSelected: actionNo })
        dispatch(setActiveAction(actionNo));
    }

    const handleChangeRole = (selected, role) => {
        const action = state.actions.find(x => x.actionNo === state.actionSelected);
        dispatch(changeActionStatus({
            role: role,
            selected: selected,
            actionData: action
        }));
    }

    const handleSaveChange = async () => {

        const { dispatch, getState } = store;

        const actinRoles = getState().configAction.actionRoles
            .filter(x =>
                (x.laststatus && x.laststatus !== x.status) ||
                (x.isNew && x.status === 'Y'));

        for (const action of actinRoles) {
            const body = {
                role: action.role,
                menuNo: action.menuNo,
                subMenuNo: action.subMenuNo,
                actionNo: action.actionNo,
                status: action.status,
            };
            await dispatch(configActionRoes(body))
        }

        setAction({ actions: [], actionSelected: '' })
        await dispatch(getConfigActionList());
        await dispatch(getRoleList());
        await dispatch(getActionRoles());

    }


    return (
        <Paper className={classes.paper}>
            <AdminTitle title="Setting" subTitle="Config Action" />



            <div className={classes.warpButton}>
                <Button variant="contained" size="medium" color="primary" className={classes.buttonSave}
                    onClick={() => handleSaveChange()}>
                    Save
                </Button>
            </div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <h4>Category</h4>
                    <div>
                        {
                            list.map(l => (
                                <div key={l.menuNo}>
                                    <div className={classes.menuRow}>
                                        {l.menuName}
                                    </div>
                                    {l.subMenu.map(s => (
                                        <div className={clsx(classes.menuRow, classes.subMenu)} key={s.subMenuNo}
                                            onClick={() => handleOnSelectSubMenu(s.actionMenu)}>

                                            {s.subMenuName}

                                        </div>

                                    ))}

                                </div>
                            ))

                        }
                    </div>
                </Grid>
                <Grid item xs={12} md={4}>
                    <h4>Action</h4>

                    <List>
                        {
                            state.actions.map((row, index) => (
                                <ListItem key={index} className={clsx(classes.listItem, {
                                    [classes.actionSelected]: state.actionSelected === row.actionNo
                                })} onClick={() => handleOnSelectAction(row.actionNo)}>
                                    <ListItemText
                                        primary={`(${row.actionNo}) - ${row.actionName}`}
                                    />
                                </ListItem>

                            ))
                        }
                    </List>
                </Grid>
                <Grid item xs={12} md={4}>
                    <h4>Role</h4>

                    <List>
                        {
                            state.actionSelected && roleSelected.map((row, index) => (
                                <ListItem key={index} className={clsx(classes.listItem)}>
                                    <ListItemIcon>
                                        <Checkbox className={classes.roleCheckbox}
                                            color="primary"
                                            edge="start"
                                            spacing={1}
                                            tabIndex={-1}
                                            checked={row.selected === 'Y'}
                                            onChange={(e) => handleChangeRole(e.target.checked, row)}
                                            disableRipple
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={row.roleName}
                                    />
                                </ListItem>

                            ))
                        }
                    </List>
                </Grid>
            </Grid >
        </Paper >
    );
}

export default ConfigActionPage;
